import React from 'react';
import { MapViewWrapper, TargetMarkerWrapper } from './styled';
import { MapSnapshot } from 'components/static-map/MapSnapshot';
import OpenMapIcon from 'assets/svg/zoom.svg';
import { connect } from 'react-redux';
import { OpenMapIconWrapper } from '../gallery/styled';
import * as actions from 'store/state/router/actions';
import { NavigateToFn, Route, State as RouteState } from 'config/routes';
import { State } from 'store/state';
import { routeSelector } from 'store/state/selectors/router';
import withEvents from 'analytics/withEvents';
import BulletinTargetMarkerILIcon from 'assets/svg/its_here_heb.svg';
import ProjectTargetMarkerIcon from 'assets/svg/its_here_heb_proj.svg';
import { ICommercialProject, InsightDescriptor, InsightType, IProject, PromotionValues } from 'utils/entities';
import { projectPageProjectSelector, projectPageCommercialProjectSelector } from 'store/state/domainData/selectors';
import { setMobileMapType } from 'store/state/insightsContext/actions';
import { InsightSection } from 'store/state/insightsContext';
import { CleanButton } from 'ds/components/button';

interface MapViewProps {
  lng: number;
  lat: number;
  navigateTo: NavigateToFn;
  route: RouteState;
  withMapAction?: boolean;
  project: IProject;
  projectCommercial: ICommercialProject;
  showPlaning: () => void;
  customMapAction?: () => void;
  type?: InsightType;
  subType?: InsightDescriptor;
}

const NEW_CONSTRUCTION = new Set([ InsightDescriptor.NewDevelopmentJobs, InsightDescriptor.NewDevelopmentJobsArea ]);

const MapView: React.FunctionComponent<MapViewProps> = ({ project, customMapAction, projectCommercial, lng, lat, navigateTo, withMapAction, route, showPlaning, type, subType }) => {
  const handleMapOpen = () => {
    if (withMapAction) {
      if (customMapAction) {
        customMapAction();
        return;
      }
      if (type === InsightType.Planning && NEW_CONSTRUCTION.has(subType)) {
        showPlaning();
      }
      else {
        navigateTo(route.name, { ...route.params, isMapActive: 1 }, { replace: true });
      }
    }
  };
  let targetMarker = null;
  switch (route.name) {
    case Route.AddressPage:
    case Route.UnitPage:
    case Route.UnitPageCommercial:
    case Route.School:
      targetMarker = <BulletinTargetMarkerILIcon />;
      break;
    case Route.ProjectPage:
      targetMarker = (project && project.promotionStatus.status === PromotionValues.Promoted)
        ? <ProjectTargetMarkerIcon />
        : <BulletinTargetMarkerILIcon />;
      break;
    case Route.ProjectPageCommercial:
      targetMarker = (projectCommercial && projectCommercial.promotionStatus.status === PromotionValues.Promoted)
        ? <ProjectTargetMarkerIcon />
        : <BulletinTargetMarkerILIcon />;
  }
  return (
    <MapViewWrapper data-auto="location-map" onClick={handleMapOpen}>
      <MapSnapshot lng={lng} lat={lat} />
      <TargetMarkerWrapper>
        {targetMarker}
      </TargetMarkerWrapper>
      {withMapAction ? (
        <OpenMapIconWrapper>
          <CleanButton onlyIcon mode="primaryNegative">
            <OpenMapIcon width={24} height={24} />
          </CleanButton>
        </OpenMapIconWrapper>
      ) : null}
    </MapViewWrapper>
  );
};

const mapDispatchToProps = {
  navigateTo: actions.navigateTo,
  showPlaning: () => setMobileMapType(InsightSection.Planning),
};

const connector = connect((state: State) => ({
  route: routeSelector(state),
  project: projectPageProjectSelector(state),
  projectCommercial: projectPageCommercialProjectSelector(state),
}), mapDispatchToProps);


export const MapViewWithEvents = connector(withEvents<MapViewProps>(sendEvent => ({
  navigateTo() {
    sendEvent('property_location_section_click', 'property');
  },
}))(MapView));


export default connector(MapView);
